import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileInfo, FileRestrictions } from '@progress/kendo-angular-upload';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {

  public readonly apiUrl: string;
  public readonly supportedFileTypes: FileRestrictions;

  constructor (@Inject(MAT_DIALOG_DATA) public data: any) {
    if(data?.apiUrl) this.apiUrl = data.apiUrl;
    if(data?.supportedFileTypes) this.supportedFileTypes = data.supportedFileTypes;
  }

  /*
  https://docs.telerik.com/kendo-ui/knowledge-base/upload-pass-error-to-template
  */
  public OnUploadError(event: any): void {
    let errorMessage = event.response?.messageErreurDetail ?? "";
    let eventFile = event.files[0];
    
    // protection contre un message d'erreur vide, ne devrait pas arriver en théorie
    if (errorMessage == "") return;

    // On ajoute un message d'erreur à l'upload
    eventFile.validationErrors = [{
      name: 'customServerError',
      message: errorMessage
    }] 
  }

}
